import { Action } from "redux"

import * as actions from "./actions"
import { IInlineAttachments } from "./index"
import { ITenForceWindow } from "../../global"

export const initialState: IInlineAttachments = {
    attachmentFields: {},
}

declare let window: ITenForceWindow

const handlers: {
    [action: string]: (
        state: IInlineAttachments,
        props: Action,
    ) => IInlineAttachments
} = {
    [actions.INITIALIZE]: (
        state,
        { customFieldDefinitionId }: actions.ActionWithCustomFieldId,
    ): IInlineAttachments => ({
        ...state,
        attachmentFields: {
            ...state.attachmentFields,
            [customFieldDefinitionId]: {
                showAllDocuments: false,
                linkedDocuments: [],
                attachmentsToLoadCounter: -1,
            },
        },
    }),

    [actions.RECEIVE_ATTACHMENTS]: (
        state,
        {
            linkedDocuments,
            customFieldDefinitionId,
        }: actions.ReceiveAttachments,
    ): IInlineAttachments => ({
        ...state,
        attachmentFields: {
            ...state.attachmentFields,
            [customFieldDefinitionId]: {
                ...state.attachmentFields[customFieldDefinitionId],
                linkedDocuments,
                attachmentsToLoadCounter: linkedDocuments.length,
            },
        },
    }),

    [actions.LOAD_MORE_ATTACHMENTS]: (
        state,
        { customFieldDefinitionId }: actions.ActionWithCustomFieldId,
    ): IInlineAttachments => ({
        ...state,
        attachmentFields: {
            ...state.attachmentFields,
            [customFieldDefinitionId]: {
                ...state.attachmentFields[customFieldDefinitionId],
                showAllDocuments: true,
            },
        },
    }),

    [actions.ATTACHMENT_LOADED]: (
        state,
        { customFieldDefinitionId }: actions.ActionWithCustomFieldId,
    ): IInlineAttachments => {
        if (
            state.attachmentFields[customFieldDefinitionId]
                .attachmentsToLoadCounter > 0
        ) {
            return {
                ...state,
                attachmentFields: {
                    ...state.attachmentFields,
                    [customFieldDefinitionId]: {
                        ...state.attachmentFields[customFieldDefinitionId],
                        attachmentsToLoadCounter:
                            state.attachmentFields[customFieldDefinitionId]
                                .attachmentsToLoadCounter - 1,
                    },
                },
            }
        }
        return state
    },

    [actions.REGISTER_FEEDBACK]: (
        state,
        { itemId, customFieldDefinitionId }: actions.RegisterFeedback,
    ): IInlineAttachments => {
        const feedbackProps = {
            key: `ipe.customfield.${itemId}.${customFieldDefinitionId}`,
            value: function (): void {
                //ignore
            },
            error: (error: unknown): void => {
                console.error(error)
            },
        }
        window.feedback.register(feedbackProps)
        return { ...state }
    },
}

export default function reducer(
    state: IInlineAttachments = initialState,
    action: Action,
): IInlineAttachments {
    const handler: (
        state: IInlineAttachments,
        action: Action,
    ) => IInlineAttachments = handlers[action.type]
    return handler ? handler(state, action) : state
}
